module.exports = [
    'common',
    'dataContext',
    'notificationsService',
    'applicationStateService',
    crossDataService
];

function crossDataService(
    common, 
    dataContext,
    notifications,
    state
) {

    var service = {
        data: {
            activeRuling: null,
            isLoading: false,
        },
        filter: {
            collection: 'ALL',
            goodsCode: null,
            rulingDateFrom: null,
            rulingDateTo: null,
            rulingNumber: null,
            subjectQuery: null,
            textQuery: null,
            NAFTARelatedOnly: 0,
            USMCARelatedOnly: 0,
            pageNumber: 1
        },
        orderBy: 'RulingDate-desc',
        loadNewRulings: loadNewRulings,
        loadMoreRulings: loadMoreRulings,
        changeActiveRuling: changeActiveRuling,
        clearActiveRuling: clearActiveRuling,
        countRulingsByHeading: countRulingsByHeading,
        resetFilter: resetFilter
    };

    return service;

    function resetFilter() {
        service.filter.collection = 'ALL';
        service.filter.goodsCode = null;
        service.filter.rulingDateFrom = null;
        service.filter.rulingDateTo = null;
        service.filter.rulingNumber = null;
        service.filter.subjectQuery = null;
        service.filter.textQuery = null;
        service.filter.NAFTARelatedOnly = 0;
        service.filter.USMCARelatedOnly= 0;
        service.filter.pageNumber = 1;
    }

    function loadNewRulings() {
        service.data.activeRuling = null;
        service.filter.pageNumber = 1;
        return loadRulings(service.filter);
    }

    function loadMoreRulings() {
        return loadRulings(service.filter);
    }

    function loadRulings(filter) {

        var sort = service.orderBy.split('-')[0];
        var order = service.orderBy.split('-')[1];

        if (sort === 'TextRank' && !filter.textQuery) {
            if (filter.subjectQuery) {
                sort = 'SubjectRank';
                service.orderBy = 'SubjectRank-desc';
            }
            else {
                sort = 'RulingDate';
                order = 'desc';
                service.orderBy = 'RulingDate-desc'
            }
        }
        if (sort === 'SubjectRank' && !filter.subjectQuery) {
            if (filter.textQuery) {
                sort = 'TextRank';
                service.orderBy = 'TextRank-desc';
            }
            else {
                sort = 'RulingDate';
                order = 'desc';
                service.orderBy = 'RulingDate-desc'
            }
        }

        var url = common.config.apiHosts.generic + '/cross/search' +
            '?goodscode=' + (filter.goodsCode || '') +
            '&pindex=' + (filter.pageNumber - 1) +
            '&psize=20' +
            '&date=' + state.filter.date +
            '&collection=' + filter.collection +
            '&sort=' + sort +
            '&order=' + order;

        if (filter.subjectQuery) {
            url += '&subject-query=' + filter.subjectQuery;
        }
        if (filter.textQuery) {
            url += '&text-query=' + filter.textQuery;
        }
        if (filter.rulingNumber) {
            url += '&ruling-number=' + filter.rulingNumber;
        }
        if (filter.rulingDateFrom) {
            url += '&ruling-date-from=' + filter.rulingDateFrom;
        }
        if (filter.rulingDateTo) {
            url += '&ruling-date-to=' + filter.rulingDateTo;
        }
        if (filter.NAFTARelatedOnly) {
            url += '&nafta-related-only=true';
        }
        if (filter.USMCARelatedOnly) {
            url += '&usmca-related-only=true';
        }

        service.data.isLoading = true;

        return dataContext.get(url).then(function (paginatedRulings) {
            service.data.isLoading = false;
            service.response = paginatedRulings;
            // if (service.response.Results.length > 0) {
            //     changeActiveRuling(service.response.Results[0].rulingNumber);
            // }
        });
    }

    function clearActiveRuling() {
        service.data.activeRuling = null;
        _.forEach(service.response.Results, function (customsRuling) {
            customsRuling.active = false;
        });
    }

    function changeActiveRuling(rulingNumber) {
        var url = common.config.apiHosts.generic + '/cross/' + rulingNumber.toString().trim() + '/';
        service.data.activeRuling = null;
        service.data.isLoading = true;
        return dataContext.get(url).then(function (activeRuling) {
            service.data.activeRuling = activeRuling;
            service.data.isLoading = false;
            notifications.publish('change_active_customs_ruling', activeRuling);
            _.forEach(service.response.Results, function (customsRuling) {
                customsRuling.active = false;
                if (customsRuling.rulingNumber === rulingNumber) {
                    customsRuling.active = true;
                }
            });
        });
    }

    function countRulingsByHeading(chapterCode) {
        var url = common.config.apiHosts.generic + '/cross/countbyheading/' + chapterCode;
        return dataContext.get(url);
    }
}